import { Pipe, PipeTransform } from '@angular/core';
import { ProjectChecklistType } from '@portal-core/project-checklists/enums/project-checklist-type.enum';

/**
 * Returns the checklist type.
 * Usage:
 *   checklistType | mcProjectChecklistTypeDisplayText
 */
@Pipe({
  name: 'mcProjectChecklistTypeDisplayText'
})
export class ProjectChecklistTypeDisplayTextPipe implements PipeTransform {
  transform(checklistType: ProjectChecklistType): string {
    switch (checklistType) {
      case ProjectChecklistType.GenericList:
        return 'Generic List';
      case ProjectChecklistType.ProjectFiles:
        return 'Project Files';
    }
  }
}
